/**
 * @desc Utils entrance
 * @author Jooger <iamjooger@gmail.com>
 * @date 1 Dec 2017
 */

'use strict'

export * from './tool'
export * from './storage'
export * from './validate'



// WEBPACK FOOTER //
// ./src/utils/index.js